import React, { ReactNode, TouchEventHandler, useState } from 'react'

import { useTranslation } from 'react-i18next'

import ChangeImage from '@/presentation/assets/svg/ChangeImage.svg'
import {
  ArrowLeft,
  ArrowRight
} from '@/presentation/assets/svg/ImageViewerArrows'
import Minimize from '@/presentation/assets/svg/Minimize.svg'

interface FullscreenPhotoProps {
  addIndex: () => void
  onClose: () => void
  paginationCounter: ReactNode
  photoUrl: string
  showOriginalPhoto: boolean
  subtractIndex: () => void
  toggleOriginalPhoto: () => void
  originalPhotoFilePath?: string
}

const touchDiff = 8

const FullscreenPhoto: React.FC<FullscreenPhotoProps> = ({
  addIndex,
  onClose,
  paginationCounter,
  photoUrl,
  showOriginalPhoto,
  subtractIndex,
  toggleOriginalPhoto,
  originalPhotoFilePath
}) => {
  const [touchPosition, setTouchPosition] = useState<number | null>(null)

  const { t } = useTranslation()

  const handleTouchStart: TouchEventHandler<HTMLElement> = event => {
    const initialTouch = event.touches.item(0)

    setTouchPosition(initialTouch.clientX)
  }

  const handleTouchMove: TouchEventHandler<HTMLElement> = event => {
    if (!touchPosition) return

    const currentTouch = event.touches.item(0)
    const diff = touchPosition - currentTouch.clientX

    if (diff > touchDiff) addIndex()

    if (diff < -touchDiff) subtractIndex()

    setTouchPosition(null)
  }

  return (
    <div
      className="relative flex max-h-screen items-center justify-center"
      onClick={event => event.stopPropagation()}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <img className="size-full max-h-screen rounded-2xl" src={photoUrl} />

      <div
        className="absolute flex size-full max-h-[768px] max-w-screen-lg flex-col justify-between p-1"
        onClick={event => event.stopPropagation()}
      >
        <img
          className="absolute right-4 top-4 cursor-pointer"
          src={Minimize}
          onClick={onClose}
        />

        {originalPhotoFilePath && (
          <img
            src={ChangeImage}
            onClick={toggleOriginalPhoto}
            className="absolute left-4 top-4 flex cursor-pointer"
            title={
              showOriginalPhoto
                ? t('SHOW_CURRENT_IMAGE', 'Mostrar imagem atual')
                : t('SHOW_ORIGINAL_IMAGE', 'Mostrar imagem original')
            }
          />
        )}

        <div className="absolute inset-y-1/2 left-4" onClick={subtractIndex}>
          <ArrowLeft />
        </div>

        <div className="absolute inset-y-1/2 right-4" onClick={addIndex}>
          <ArrowRight />
        </div>

        <div className="absolute inset-x-1/2 bottom-2 flex justify-center text-xs text-white sm:text-base">
          {paginationCounter}
        </div>
      </div>
    </div>
  )
}

export default FullscreenPhoto
